import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Config } from "@app/config/api.config";
import { Observable } from "rxjs";

export interface AbstinenceRequest {
  id?: string;
  personId: string;
  description: string;
  document?: string;
  startDate: string | Date;
  endDate: string | Date;
}

@Injectable({
  providedIn: "root",
})
export class AbstinenceService {
  constructor(private http: HttpClient) {}

  create(abstinence: AbstinenceRequest, file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("request", JSON.stringify(abstinence));

    return this.http.post<any>(`${Config.webApiUrl}/v1/abstinence`, formData);
  }
}
